const getInitials = (name) => {
  const parts = `${name || ""}`.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

export const createInitialsAvatar = (name) => {
  const initials = getInitials(name).replace(/[^A-Z0-9?]/g, "").slice(0, 2) || "?";
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160"><rect width="160" height="160" rx="80" fill="#EEF2FF"/><text x="80" y="84" text-anchor="middle" dominant-baseline="middle" fill="#1234CD" font-family="Arial,Helvetica,sans-serif" font-size="54" font-weight="700">${initials}</text></svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
